<template>
  <div>
    <main class="main">
      <nav aria-label="breadcrumb" class="breadcrumb-nav mb-3 bg-light">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/dashboard">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/meeeting">Meeting</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Dettaglio
            </li>
          </ol>
        </div>
        <!-- End .container -->
      </nav>
      <alert-component :alertType="'success'" :message="successMessage"></alert-component>
      <alert-component :alertType="'danger'" :message="error"></alert-component>
      <LoadedComponent :loading="loading" />
      <!-- End .breadcrumb-nav -->
      <div class="page-content" v-if="!loading">
        <div class="container">
          <div class="row" v-if="meeting.owner">
            <div class="col-md" v-if="meeting.allspeakers == false">
              <div class="text-center mb-2 mb-md-0">
                <button type="button" class="btn btn-primary btn-sm" data-target="#add-invitations" data-toggle="modal">
                  <i class="las la-users" style="font-size: 100%"></i>
                  Aggiungi relatore
                </button>
              </div>
            </div>

            <div class="col-md" v-if="meeting.owner">
              <div class="text-center mb-2 mb-md-0">
                <router-link :to="'/meeting/edit/' + this.meeting.slug" class="btn btn-primary">
                  <i class="las la-cog"></i> Cambia il meeting
                </router-link>
              </div>
            </div>
            <div class="col-md" v-if="meeting.status == 'progress' && meeting.owner">
              <div class="text-center mb-2 mb-md-0">
                <button type="button" class="btn btn-danger" @click="closeCall">
                  Chiudi la call e ferma la registrazione
                </button>
              </div>
            </div>
            <div class="col-md" v-if="
              meeting.status == 'programming' ||
              meeting.status == 'publish' ||
              meeting.status == 'error'
            ">
              <div class="text-center mb-2 mb-md-0">
                <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#confirm-delete">
                  Annulla l'evento
                </button>
              </div>
            </div>
          </div>

          <h4 class="d-flex justify-content-center pt-2">
            {{ meeting.name }}
          </h4>
          <div class="entry-content">
            <div class="text-md-left text-center">
              <p>{{ meeting.description }}</p>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-9 pt-4">
              <article class="entry">
                <figure class="entry-media pb-2">
                  <div v-if="meeting.owner == 1 || meeting.partecipants == true" class="text-center">
                    <a :href="domainApi + '/meeting/' + meeting.id + '/' + token" class="btn btn-primary btn-lg"
                      target="_blank" id="enter_call">
                      <i class="las la-video"></i>Entra in call</a>
                  </div>
                  <div v-else-if="meeting.invitations == true">
                    <video-component :options="optionsVideo"></video-component>
                    <p>
                      La live avrà inizio 120 secondi dopo l'ingresso
                      dell'organizzatore
                    </p>
                  </div>
                  <div v-if="meeting.owner == 1" class="text-center">
                    <a :href="meeting.admin_zoom_url" class="btn btn-danger btn-lg mt-3">Modalita regia
                    </a>
                  </div>
                </figure>

                <div class="entry-body">
                  <div class="entry-meta">
                    <span class="entry-author">
                      by <span>{{ meeting.author }}</span>
                    </span>
                    <span class="meta-separator">|</span>
                    <span>{{ meeting.datetime_start }}</span>
                    <span class="meta-separator">|</span>
                    <span>{{ comments.length }} commenti</span>
                  </div>

                  <div class="entry-content mt-2">
                    <TestComponent :activity_id_params="meeting.activity_id"></TestComponent>
                  </div>
                </div>
              </article>
            </div>

            <aside class="col-lg-3">
              <div class="sidebar">
                <h3 class="widget-title">Commenti</h3>
                <CommentFormComponent :activity_id="meeting.activity_id" :successmessagecomment="successMessageComment"
                  @setSuccessMessage="setSuccessMessage" :errormessagecomment="errorMessageComment"
                  @setErrorMessage="setErrorMessage" :loadComments="loadComments"
                  :comment_permission="comment_permission"></CommentFormComponent>
                <!-- End .widget-title -->

                <CommentListComponent :activity_id="meeting.activity_id" :successmessagecomment="successMessageComment"
                  @setSuccessMessage="setSuccessMessage" :comments="comments" :loadComments="loadComments"
                  :comment_permission="comment_permission" :model="'meeting'" class="mt-4"></CommentListComponent>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </main>

    <div class="modal fade" tabindex="-1" role="dialog" id="confirm-delete">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Conferma eliminazione</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-delete-meeting">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <p>Sei sicuro di voler eliminare e annullare il meeting?</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              Annulla
            </button>
            <button type="button" class="btn btn-outline-danger" @click="deleteMeeting">
              Elimina
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="add-invitations">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Aggiungi relatori</h5>
            <div class="alert alert-success" v-if="successMessageInvitated">
              <h5 style="
                  color: white;
                  text-align: center;
                  font-family: sans-serif;
                ">
                {{ successMessageInvitated }}
              </h5>
            </div>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="close-modal-invitations">
              <span aria-hidden="true"><i class="icon-close"></i></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="container">
              <ul>
                <li v-for="(user, index) in usersAddInvitations" :key="user.id">
                  <div class="icheck-wetasphalt mt-3">
                    <input type="checkbox" :id="'chb1-' + user.id" @click="addInvitations(user.id, index)" />
                    <label :for="'chb1-' + user.id">{{ user.name }} {{ user.lastname }}</label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
import { useAuth } from "@/stores/auth.js";
import httpservices from "@/services/httpservices.js";
import LoadedComponent from "@/components/LoadedComponent.vue";
import router from "@/router";
import VideoComponent from "@/components/VideoComponent.vue";
import CommentFormComponent from "@/components/CommentForm.vue";
import CommentListComponent from "@/components/CommentList.vue";
import AlertComponent from "@/components/AlertComponent.vue";
import TestComponent from "@/components/TestComponent.vue";
import { useToast } from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";
export default {
  name: "ShowMeeting",
  props: ["slug"],
  components: {
    LoadedComponent,
    VideoComponent,
    CommentFormComponent,
    CommentListComponent,
    AlertComponent,
    TestComponent,
  },
  data() {
    return {
      meeting: [],
      successMessage: "",
      error: "",
      comments: [],
      loading: true,
      optionsVideo: {},
      errorMessageComment: "",
      successMessageComment: "",
      comment_permission: false,
      usersAddInvitations: [],
      successMessageInvitated: "",
      domainApi: "",
      //domainApi: "https://neurohubproduzione-du674cefya-oc.a.run.app",
      token: "",
    };
  },
  mounted() {
    const domain = window.location.hostname;

    switch (domain)
    {
      case "localhost":
        this.domainApi = "http://127.0.0.1";

        break;
      case "demo.vascularclass.it":
        this.domainApi = "https://test.gestione.vascularclass.it";
        break;
      case "vascularclass.it":
      case "www.vascularclass.it":
        this.domainApi =
          "https://gestione.vascularclass.it";
        break;
    }
    this.token = localStorage.getItem("token");
    this.getMeeting();
    this.loadPermission();
  },

  methods: {
    async loadPermission() {
      await httpservices
        .checkPermission(0, "comments", "create_comment")
        .then((response) => {
          this.comment_permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
      await httpservices
        .checkPermission(1, "meeting", "")
        .then((response) => {
          this.permission = response.data.permission;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    updateComments(newComments) {
      // Emit an event to update the prop value outside the component
      this.$emit("update:comments", newComments);
    },
    setSuccessMessage(value) {
      this.successMessageComment = value;
    },
    setErrorMessage(value) {
      this.errorMessageComment = value;
    },
    async addInvitations(userId, index) {
      await httpauth
        .get("/meetings/add-speakers/" + userId + "/" + this.meeting.id)
        .then((response) => {
          const $toast = useToast();
          if (response.data.status == true)
          {
            this.successMessageInvitated = response.data.message;
            this.usersAddInvitations.splice(index, 1);
            $toast.open({
              message: response.data.message,
              type: "success",
              position: "top-right",
              // all of other options may go here
            });
            return;
          }

          $toast.open({
            message: response.data.message,
            type: "warning",
            position: "top-right",
            // all of other options may go here
          });
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.status == 401)
          {
            this.error = error.response.data.message;
          }
        });
    },
    async loadComments() {
      try
      {
        const response = await httpservices.loadComments(
          this.meeting.activity_id
        );
        this.comments = response.data.data;
        this.loading = false;
      } catch (error)
      {
        console.log(error);
      }
    },
    async deleteMeeting() {
      await httpauth
        .delete("/meetings/" + this.meeting.slug)
        .then((response) => {
          if (response.data.status == 1)
          {
            localStorage.setItem(
              "messageSuccessMeeting",
              response.data.message
            );
            location.href = "/meeting";
            return;
          }
          localStorage.setItem("messageErrorMeeting", response.data.message);
          location.href = "/meeting";
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
        });
    },
    async closeCall() {
      await httpauth
        .get("/meetings/stop-register/" + this.meeting.slug)
        .then((response) => {
          if (response.data.status == 1)
          {
            router.push("/meeting");
            return;
          }
          this.error = response.data.message;
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          }
          if (error.response.status == 401 || error.response.status == 404)
          {
            this.error = error.response.data.message;
          }
        });
    },
    async getMeeting() {
      await httpauth
        .get("/meetings/" + this.slug)
        .then((response) => {
          this.loading = false;
          if (response.data.data)
          {
            this.meeting = response.data.data;
            if (
              this.meeting.status == "programming" ||
              this.meeting.status == "progress"
            )
            {
              this.loadComments();

              this.optionsVideo = this.getOptons(this.meeting.streaming_url);
              return;
            }

            router.push("meeting/registration/" + this.meeting.slug);
          }
          router.push("/meeting");
        })
        .catch((error) => {
          if (
            error.response.status == 401 &&
            error.response.data.message == "Unauthenticated."
          )
          {
            const auth = useAuth();
            auth.clearToken();
            window.location.href = "/";
          } else if (error.response.status == 403)
          {
            localStorage.setItem(
              "messageErrorMeeting",
              error.response.data.message
            );
            router.push("/meeting");
          }
        });
    },

    getOptons(path) {
      return {
        controls: true,
        autoplay: true,
        fluid: true,
        // Puoi aggiungere ulteriori opzioni personalizzate qui

        // Esempio di configurazione del sorgente del video
        sources: [
          {
            src: path,
            type: "video/mp4",
          },
        ],
      };
    },
  },
};
</script>

<style scoped>
.entry-media {
  background-color: transparent;
}
</style>